import { render } from "./Terminal_security.vue?vue&type=template&id=23593700&scoped=true"
import script from "./Terminal_security.vue?vue&type=script&lang=js"
export * from "./Terminal_security.vue?vue&type=script&lang=js"

import "./Terminal_security.vue?vue&type=style&index=0&id=23593700&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23593700"]])

export default __exports__